/**
    @namespace {Object} formatLocale
    A set of default locale formatters used when assigning suffixes and currency in numbers.
*/ var formatLocale = {
    "ar-SA": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            " \u0623\u0644\u0641",
            " \u0645\u0644\u064a\u0648\u0646",
            " \u0628\u0644\u064a\u0648\u0646",
            " \u062a\u0631\u064a\u0644\u064a\u0648\u0646",
            " \u0643\u0648\u0627\u062f\u0631\u064a\u0644\u064a\u0648\u0646",
            " \u0643\u0648\u064a\u0646\u062a\u064a\u0644\u064a\u0648\u0646",
            " \u0633\u0643\u0633\u062a\u0644\u064a\u0648\u0646",
            "\u0633\u0628\u062a\u064a\u0644\u064a\u0648\u0646"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "SAR ",
            ""
        ]
    },
    "en-GB": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "M",
            "B",
            "T",
            "q",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "\u00a3",
            ""
        ]
    },
    "en-US": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "M",
            "B",
            "T",
            "q",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "$",
            ""
        ]
    },
    "en-SA": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            " thousand",
            " million",
            " billion",
            " trillion",
            " quadrillion",
            " quintillion",
            " sextillion",
            "septillion"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "$",
            ""
        ]
    },
    "es-CL": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "M",
            "MM",
            "B",
            "T",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ".",
            decimal: ","
        },
        currency: [
            "$",
            ""
        ]
    },
    "es-MX": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "M",
            "MM",
            "B",
            "T",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "$",
            ""
        ]
    },
    "es-ES": {
        separator: "",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "mm",
            "b",
            "t",
            "q",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ".",
            decimal: ","
        },
        currency: [
            "\u20ac",
            ""
        ]
    },
    "et-EE": {
        separator: " ",
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "tuhat",
            "miljonit",
            "miljardit",
            "triljonit",
            "q",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: " ",
            decimal: ","
        },
        currency: [
            "",
            "eurot"
        ]
    },
    "fr-FR": {
        suffixes: [
            "y",
            "z",
            "a",
            "f",
            "p",
            "n",
            "\u00b5",
            "m",
            "",
            "k",
            "m",
            "b",
            "t",
            "q",
            "Q",
            "Z",
            "Y"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: " ",
            decimal: ","
        },
        currency: [
            "\u20ac",
            ""
        ]
    },
    "zh-CN": {
        separator: "",
        suffixes: [
            "\u5e7a",
            "\u4ed4",
            "\u963f",
            "\u98de",
            "\u76ae",
            "\u7eb3",
            "\u5fae",
            "\u6beb",
            "",
            "\u5343",
            "\u5146",
            "\u5409",
            "\u592a",
            "\u62cd",
            "\u827e",
            "\u6cfd",
            "\u5c27"
        ],
        grouping: [
            3
        ],
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        currency: [
            "\u00a5",
            ""
        ]
    }
};
export default formatLocale;

//# sourceMappingURL=formatLocale.js.map